// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dtsLeftCol {
  margin-right: 10px;
}

.dtsNowRBButton {
  margin-bottom: 1.25em;
}

.dtsTPFirstCol {
  align-self: center;
  width: 200px;
}

.dtsTPSecCol {
  width: 200px;
}

.dtsChangeText {
  width: 200px;
  margin-right: 10px;
}

.dtsPreviewIcon {
  align-self: center;
  margin: 0px 10px;
}

.dtsMPFirstCol {
  width: 200px;
}

.dtsMPSecCol {
  width: 200px;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/dynamictimepoint/dynamic.timepoint.settings.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".dtsLeftCol {\n  margin-right: 10px;\n}\n\n.dtsNowRBButton {\n  margin-bottom: 1.25em;\n}\n\n.dtsTPFirstCol {\n  align-self: center;\n  width: 200px;\n}\n\n.dtsTPSecCol {\n  width: 200px;\n}\n\n.dtsChangeText {\n  width: 200px;\n  margin-right: 10px;\n}\n\n.dtsPreviewIcon {\n  align-self: center;\n  margin: 0px 10px;\n}\n\n.dtsMPFirstCol {\n  width: 200px;\n}\n\n.dtsMPSecCol {\n  width: 200px;\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
